import UnmountHandler from './UnmountHandler';

export default UnmountHandler;
